import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { OvhNickhandleService } from '../../services/ovh-nickhandle.service';
import { OvhMonitService } from '../../services/ovh-monit.service';

@Component({
  selector: 'disks',
  templateUrl: './disks.component.html',
  styleUrls: ['./disks.component.css']
})
export class DisksComponent implements OnInit  {
  modalRef: BsModalRef;
  
  nickhandle : any;
  systems : any;
  selected : any;
  instanceDisk : any;
  rows : any;
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  
  @Input() filter = 'ALL';
  
  constructor(
  	private readonly modalService: BsModalService,
  	private readonly router: Router,
  	private readonly route: ActivatedRoute,
  	private readonly nickhandleService: OvhNickhandleService,
  	private readonly monitService: OvhMonitService) {
  }
  
  ngOnInit() {
  	this.route.parent.paramMap.subscribe((params: ParamMap) => {
  		console.log(params	);
        const nickhandle = params.get('nickhandle');
        this.nickhandleService.getNickhandle(nickhandle).subscribe(
        	data => 
        		{ 
        			this.nickhandle = data;  
        		}
        	);
        this.monitService.getDiskStatus(nickhandle, this.filter).subscribe(
        	data =>
        		{
        			this.rows = this.systems = data;
        			this.loadingIndicator = false;
        		}
        );
      }
    );
   
  }
    
  updatedAtStatusClass({ row, column, value }): any {
    return {
        'bg-success': row.updatedAtStatus === 'OK',
        'bg-warning': row.updatedAtStatus === 'WARNING',
        'bg-danger': row.updatedAtStatus === 'DANGER',
    };
  }
  
   onSort($event) {
  }
  
  onSelect({ selected }) {
  	this.selected = selected[0];
  	this.instanceDisk = null;
  	this.monitService.getInstanceDisk(this.nickhandle.code, selected[0].projectId, selected[0].instanceId)
  		.subscribe(result => {
  			console.log(result);
  			this.instanceDisk = result;
  		});
  }
  
  systemDiskStatusClass({ row, column, value }): any {
    return {
        'bg-success': row.systemDiskStatus === 'OK',
        'bg-warning': row.systemDiskStatus === 'WARNING',
        'bg-danger': row.systemDiskStatus === 'DANGER',
        'bg-light': row.systemDiskStatus === 'NO_DISK',
    };
  }
  
  dataDiskStatusClass({ row, column, value }): any {
    return {
        'bg-success': row.dataDiskStatus === 'OK',
        'bg-warning': row.dataDiskStatus === 'WARNING',
        'bg-danger': row.dataDiskStatus === 'DANGER',
        'bg-light': row.dataDiskStatus === 'NO_DISK',
    };
  }
  
  backupDiskStatusClass({ row, column, value }): any {
    return {
        'bg-success': row.backupDiskStatus === 'OK',
        'bg-warning': row.backupDiskStatus === 'WARNING',
        'bg-danger': row.backupDiskStatus === 'DANGER',
        'bg-light': row.backupDiskStatus === 'NO_DISK',
    };
  }
  
}
